(() => {
  const init = root => {
    if (root.dataset.clhwReady) return;
    root.dataset.clhwReady = 'true';
    const button = root.querySelector('[data-clhw-copy]');
    const code = root.querySelector('[data-clhw-code]');
    const label = root.querySelector('[data-clhw-copy-label]');
    const status = root.querySelector('[data-clhw-status]');
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      button.disabled = true;
      let copied = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code.value);
          copied = true;
        }
      } catch {}
      if (!copied) {
        const helper = document.createElement('textarea');
        helper.value = code.value;
        helper.readOnly = true;
        helper.setAttribute('aria-hidden', 'true');
        helper.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;padding:0;border:0;opacity:0;pointer-events:none';
        document.body.appendChild(helper);
        try {
          helper.focus({preventScroll: true});
          helper.select();
          copied = document.execCommand('copy');
        } catch {} finally { helper.remove(); }
        button.focus({preventScroll: true});
      }
      status.textContent = copied ? button.dataset.success : button.dataset.failure;
      status.dataset.state = copied ? 'copied' : 'manual';
      label.textContent = copied ? button.dataset.copiedLabel : button.dataset.copyLabel;
      button.disabled = false;
      if (copied) button.focus({preventScroll: true});
    });
  };
  document.querySelectorAll('[data-clhw]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-clhw]').forEach(init));
})();
